<template>
    <div class="innerBox" style="background-color: #900C3F; padding-top:18px">
        <div class="row" style="display: flex; justify-content: space-between;">
            <h5 class="text-white" style="margin:auto 0">Finance</h5>
        </div>

        <div class="divider"></div>

        <div class="align-spacely" style="height: 840px;">
            <div class="row">
                <div class="col">
                    <h3 class="custom-text-pink">Revenue Detail</h3>
                    <div class="pl-2 mt-3">
                        <table class="w-100">
                            <tr>
                                <td colspan="2" style="color:white; font-size:22px; font-weight:bold">Estimasi Pendapatan</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="color:white; font-size:20px; padding-bottom:20px; padding-left:10px;"> Rp.&nbsp;{{ estimationRevenue }}</td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pl-3 pr-3">Belum Terbayar</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.sum_unpaid) }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="color:white; font-size:22px; font-weight:bold; padding-top:20px">Income</td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pl-3 pr-3">Own Risk</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.own_risk) }}</td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pl-3 pr-3">Terima Pembayaran</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.sum_paid) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <div class="row">
                <div class="col">
                    <h3 class="custom-text-pink">Rincian Pengeluaran</h3>
                    <div class="pl-2 mt-3">
                        <table class="w-100">
                            <tr>
                                <td class="home-table-content font-weight-bold pr-3">Pembelian Sparepart WO
                                    (Perkiraan)</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.pembelian_sparepart_wo) }}
                                </td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pr-3">Cost Pekerja</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.cost_pekerja) }}</td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pr-3">Pembelian Stok Barang</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.pembelian_stock_barang) }}
                                </td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold pr-3">Petty Cash</td>
                                <td class="home-table-content text-center">Rp.&nbsp;{{ numberWithCommas(data.petty_cash) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <div class="row">
                <div class="col">
                    <h3 class="custom-text-pink">Statistik</h3>
                    <div class="pl-2 mt-3">
                        <table class="w-100">
                            <tr>
                                <td class="home-table-content font-weight-bold pr-2">Pendapatan Rata Rata Per WO
                                </td>
                                <!-- <td class="home-table-content text-center">Rp.&nbsp;{{ averageStatistics.revenuePerWO }}</td> -->
                                <td class="home-table-content text-center">Rp. -</td>
                            </tr>
                            <!-- <tr>
                                <td class="home-table-content font-weight-bold">Average Cost Per WO</td>
                                <td class="home-table-content text-center">{{ numberWithCommas(2000000) }}</td>
                            </tr>
                            <tr>
                                <td class="home-table-content font-weight-bold">Average Profit Per WO</td>
                                <td class="home-table-content text-center">{{ numberWithCommas(8000000) }}</td>
                            </tr> -->
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : ['data'],
        mounted () {

        },
        computed : {
            estimationRevenue() {
                console.log(this.data.sum_unpaid);
                console.log(this.data.own_risk);
                console.log(this.data.sum_paid);
                return this.numberWithCommas(
                    parseInt(this.data.sum_unpaid) +
                    // parseInt(this.data.sum_kwitansi) +
                    parseInt(this.data.own_risk) +
                    parseInt(this.data.sum_paid)
                )
            },
        },
        methods : {

        }
    }
</script>

<style scoped>
    .innerBox {
        overflow-y: auto;
    }
</style>